import { NgModule } from '@angular/core';
import { TableGenericFiltersComponent } from './table-generic-filters.component';

@NgModule({
	declarations: [],
	imports: [TableGenericFiltersComponent],
	exports: [TableGenericFiltersComponent],
})
export class TableGenericFiltersModule {}
